import React from "react";

import Placeholder, { Rect } from "components/Placeholder";

const SearchFiltersPlaceholder: React.FC<{
  count?: number;
}> = ({ count = 6 }) => {
  return (
    <>
      <div className="mb-sm">
        <Placeholder width="100%" height="20">
          <Rect width="132" height="20" />
        </Placeholder>
      </div>
      <div className="flex flex-row mb-lg">
        {new Array(count).fill(null).map((_, i) => {
          return (
            <div className="mr-lg" key={i}>
              <Placeholder width="70" height="24">
                <Rect width="70" height="24" />
              </Placeholder>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default SearchFiltersPlaceholder;
